module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col report-col"
  }, [_c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    attrs: {
      "to": "reports/pending-payments"
    }
  }, [_vm._v("Pending Payments")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col report-col"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Reports")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34485376!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Index.vue
// module id = 378
// module chunks = 0